// extracted by mini-css-extract-plugin
export default {"root":"Agreement_root__EfBOQ","title":"Agreement_title__Jxgtn","infoGroup":"Agreement_infoGroup__S43Ch","info":"Agreement_info__w5Jpv"};